<script setup lang="ts">
import { AppConfirmationModal } from '@libs/ui';

interface RemoveDestinationModalEmits {
  (eventName: 'close'): void;
  (eventName: 'confirm'): void;
}

const emit = defineEmits<RemoveDestinationModalEmits>();
</script>

<template>
  <AppConfirmationModal
    @close="emit('close')"
    @cancel="emit('close')"
    @confirm="emit('confirm')"
  >
    <template #title>
      <span>{{ $t('planner.remove_destination') }}?</span>
    </template>
    <template #content>
      <span>{{ $t('planner.remove_accommodation_message') }}</span>
    </template>
    <template #cancelButton>
      <span>{{ $t('planner.cancel') }}</span>
    </template>
    <template #applyButton>
      <span>{{ $t('planner.remove_destination') }}</span>
    </template>
  </AppConfirmationModal>
</template>
